import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center w-full h-full" }
const _hoisted_2 = { class: "w-11/12 pt-16 bg-white sm:w-96 max-w-96" }
const _hoisted_3 = { class: "my-5" }
const _hoisted_4 = { class: "px-4 space-y-6 text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Reset Your Password", -1)

import { apiUsers } from '@/api/users';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import FloatingHeaderTextField from '@/components/Inputs/FloatingHeaderTextField.vue';
import Logo from '@/components/UI/Logo.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();

const password = ref('');
const confirmPassword = ref('');
const passwordError = ref('');

async function reset() {
  passwordError.value = '';
  if (password.value.length >= 8 && password.value === confirmPassword.value) {
    const { link } = route.query;
    await apiUsers.resetPassword({
      Link: (link || '').toString(),
      Password: password.value,
      ConfirmPassword: confirmPassword.value,
    });
    router.push('login');
  } else {
    passwordError.value =
      'The passwords must match and be at least 8 characters in length.';
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Logo),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(FloatingHeaderTextField, {
            title: "New Password",
            modelValue: password.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
            type: "password"
          }, null, 8, ["modelValue"]),
          _createVNode(FloatingHeaderTextField, {
            title: "Confirm Password",
            modelValue: confirmPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
            type: "password",
            "validation-error": passwordError.value
          }, null, 8, ["modelValue", "validation-error"]),
          _createVNode(_component_Button, {
            label: "Reset Password",
            type: "primary",
            class: "w-full py-3 font-bold rounded text-md",
            onClick: reset
          })
        ])
      ])
    ])
  ]))
}
}

})